import React from 'react';

import { Partner } from 'src/reducers/partner/types';

import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';

import { PARTNER_TYPES } from 'Constants/partnerTypes';

import ConfigVersionMessage from 'Components/utility/ConfigVersionMessage';

import backArrowImg from 'Images/back-arrow.svg';

const backToHome = () => {
  mediator.publish('router:navigate', '/');
};

interface CommonProps {
  showBack?: boolean;
  showDesc?: boolean;
}

interface DefaultProps extends CommonProps {
  appType?: 'default' | 'quickshare' | 'otherConnections' | 'inbound';

  app: {
    id: string;
    transGroupKey: string;
    logo: string | null;
  };
}

interface PartnerProps extends CommonProps {
  appType?: 'partner';

  app: Partner;
}

type Props = DefaultProps | PartnerProps;

const LibreAppWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  app,
  appType,
  children,
  showBack,
}) => {
  let name = '';

  switch (appType) {
    case 'partner':
      switch (app.type) {
        case PARTNER_TYPES.API:
        case PARTNER_TYPES.COMMERCIAL_API:
        case PARTNER_TYPES.REDOX:
        case PARTNER_TYPES.FHIR:
        case PARTNER_TYPES.INBOUND:
        case PARTNER_TYPES.INSULET:
          name = app.name;
          break;
        default:
          name = i18n.t(`${(app as Partner).transGroupKey}.brandName`);
          break;
      }

      break;

    case 'quickshare':
      name = i18n.t(`${app.transGroupKey}.brandNameCode`);
      break;

    default:
      name = i18n.t(`${app.transGroupKey}.brandName`);
      break;
  }

  return (
    <div id={`connectedApp-${app.id}`} className="d-flex flex-column">
      {/* App Name/Logo */}
      <div className="d-flex justify-content-between mt-4 mb-4">
        {app.logo ? (
          <img
            id="logo-img"
            src={app.logo}
            alt={name}
            style={{
              maxHeight: '50px',
              maxWidth: '200px',
            }}
          />
        ) : (
          <span id="logo-text" className="text-xxxl line-height-xs">
            {name}
          </span>
        )}
        <ConfigVersionMessage />
      </div>

      {children}

      {/* Back To Home */}
      {showBack && (
        <button
          id="backToHome-btn"
          className="d-flex justify-content-center align-items-center align-self-center btn btn-link p-0 mt-4"
          onClick={backToHome}
        >
          <img className="rtlFlip mr-2" src={backArrowImg} />
          <span>{i18n.t('Common.backToHome', { context: 'cap' })}</span>
        </button>
      )}
    </div>
  );
};

export default LibreAppWrapper;
